import { Box, Breadcrumbs, Link, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { appColors } from "../../../constants/theme";
import { resolveBreadcrumbLabel } from "../../../utils/pageBreadcrumbs";

const PageBreadcrumb = ({ crumbs = [], subtitle }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const visibleCrumbs = crumbs.filter((crumb) => resolveBreadcrumbLabel(crumb, t));
  if (!visibleCrumbs.length) return null;

  // Mobilde sadece son crumb (sayfa başlığı) — taşmayı önler
  const displayCrumbs = isMobile
    ? [visibleCrumbs[visibleCrumbs.length - 1]]
    : visibleCrumbs;
  const isSingleCrumb = displayCrumbs.length === 1;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
        flex: 1,
        minWidth: 0,
        mr: { xs: 1, md: 2 },
      }}
    >
      <Breadcrumbs
        separator={
          <NavigateNextIcon sx={{ fontSize: "1rem", color: appColors.gray500 }} />
        }
        aria-label="breadcrumb"
        maxItems={isMobile ? 1 : 8}
        sx={{
          width: "100%",
          maxWidth: "100%",
          "& .MuiBreadcrumbs-ol": {
            flexWrap: "nowrap",
            alignItems: "center",
          },
          "& .MuiBreadcrumbs-li": {
            minWidth: 0,
            maxWidth: isSingleCrumb ? "100%" : "45%",
          },
          "& .MuiBreadcrumbs-li:last-of-type": {
            maxWidth: "100%",
          },
        }}
      >
        {displayCrumbs.map((crumb, index) => {
          const label = resolveBreadcrumbLabel(crumb, t);
          const isLast = index === displayCrumbs.length - 1;
          const isClickable = Boolean(crumb.to) && !isLast;

          if (isClickable) {
            return (
              <Link
                key={`${crumb.to}-${index}`}
                component={RouterLink}
                to={crumb.to}
                underline="hover"
                sx={{
                  color: appColors.gray500,
                  fontSize: { xs: "0.8rem", md: "0.875rem" },
                  fontWeight: 500,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "block",
                }}
              >
                {label}
              </Link>
            );
          }

          return (
            <Typography
              key={`${label}-${index}`}
              sx={{
                color: appColors.gray900,
                fontWeight: 700,
                fontSize: {
                  xs: "1rem",
                  md: isLast && isSingleCrumb ? "1.3rem" : "0.875rem",
                },
                lineHeight: 1.3,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "100%",
              }}
            >
              {label}
            </Typography>
          );
        })}
      </Breadcrumbs>
      {subtitle && !isMobile ? (
        <Typography
          variant="body2"
          sx={{
            color: appColors.gray500,
            fontSize: "0.9rem",
            mt: 0.5,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "100%",
          }}
        >
          {subtitle}
        </Typography>
      ) : null}
    </Box>
  );
};

export default PageBreadcrumb;
